import { PolygonCoords } from '../enums/maps';
import { BaseModel } from './base';


export interface Zones extends BaseModel {
    franchiseId: ModelId | null,
    paths: PolygonCoords[];
}

export const newZone: Zones = {
    id: 0,
    franchiseId: null,
    paths: []
};
